<!--<div id="support" class="page-layout simple fullwidth"  fusePerfectScrollbar>-->
<div
  id="release-note"
  class="page-layout simple fullwidth inner-scroll flex-column"
>
  <!-- HEADER -->
  <div class="gt2-theme">
    <div
      class="header accent pl-24 pr-24 h-80 mat-elevation-z1 flex-row-start-center"
      fusePerfectScrollbar
      [ngStyle]="{
        width: '100%',
        'overflow-x': isSmallScreen ? 'scroll' : 'none',
      }"
    >
      <div class="flex-row-start-center">
        <mat-icon class="header-page-icon">help</mat-icon>
        <div class="release-title">{{ "RELEASENOTE.TITLE" | translate }}</div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- GT2 https://docs.google.com/document/d/e/2PACX-1vSgfsrYvD35H0JuM0M8dygJJRk0cnrRj36yMjXNQTbDnAqHjqBFOY7VD2oUsGAQieanqdPY8LRFeYmh/pub?embedded=true -->
  <iframe
    width="100%"
    height="100%"
    class="doc-iframe"
    *ngIf="translate.currentLang === 'en-CA' && isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vQz8UYoFsjHVOs2MyoSVCmPtFvWkI4Jl8NUXuKypYuv0HL4LpglXCKGMumBVpLfslx2E3fn7bHw9-mU/pub?embedded=true"
  >
  </iframe>

  <iframe
    class="px-24"
    width="100%"
    height="100%"
    *ngIf="translate.currentLang === 'en-CA' && !isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vQz8UYoFsjHVOs2MyoSVCmPtFvWkI4Jl8NUXuKypYuv0HL4LpglXCKGMumBVpLfslx2E3fn7bHw9-mU/pub?embedded=true"
  >
  </iframe>

  <!-- GT2 https://docs.google.com/document/d/e/2PACX-1vTPxTCVDChLhyIye6p88Ius2vM4r7qjZqEhfF_zNBmJxSBIX3cm8s2bUs4Jeyu-5onp0Qy5mJdfR-MO/pub?embedded=true -->

  <iframe
    width="100%"
    height="100%"
    class="doc-iframe"
    *ngIf="translate.currentLang === 'fr-CA' && isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vRfLqUZfKJskhgqM7x2Mie3ogrI8-n-d1k-uXSbtzHMuuO7zxi8wgngzq-JiTYCfQO8oga_I3y48u0q/pub?embedded=true"
  >
  </iframe>

  <iframe
    class="px-24"
    width="100%"
    height="100%"
    *ngIf="translate.currentLang === 'fr-CA' && !isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vRfLqUZfKJskhgqM7x2Mie3ogrI8-n-d1k-uXSbtzHMuuO7zxi8wgngzq-JiTYCfQO8oga_I3y48u0q/pub?embedded=true"
  >
  </iframe>
</div>
